import React, { useContext } from 'react';
import './sidebar.scss';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from '@material-ui/core';
import iconClose from '../../../public/images/icon-close.png';
import { checkSipSubscribed, handleLogout } from '../../../../services/helperFunctions';
import { UserLoginContext } from '../../../../contexts/LoggedInUserContext';

export default function SwipeableTemporaryDrawer(props) {
  const {
    value, toggleDrawer, wallet,
  } = props;
  const { userData } = useContext(UserLoginContext);
  const isSubscribed = checkSipSubscribed(userData?.listsubscriptions);

  const list = () => (
    <div className="swipe-drawer">
      <div
        className="makeStyles-list-1"
        role="presentation"
        onKeyDown={toggleDrawer(false)}>
        <div className="side-bar-top">
          <img className="logo" src="https://www.ketto.org/assets/images/logo-light-bg.svg" alt="img-loading"></img>
          <div className="close" onClick={toggleDrawer(false)}>
            <img className="closeButton" src={iconClose} alt="img-loading"></img>
          </div>
        </div>
        <List>
          {['View Profile', 'My Donations', 'My Wallet', 'My SIP Dashboard', 'My Preferences', 'Logout'].map((text, index) => (
            <ListItem button key={text} className={wallet.length == 0 ? text && text.split(' ') && text.split(' ')[1] : ''}>
              {
                index == 0
                && (
                  <div
                    className="options"
                    onClick={() => props.handleRedirection('/editprofile', true)}>
                    <ListItemText primary={text} />
                  </div>
                )
              }
              {
                index == 1
                && (
                  <div className="options" onClick={() => props.handleRedirection('/mydonations', true)}>
                    <ListItemText primary={text} />
                  </div>
                )
              }
              {
                index == 2 && wallet.length !== 0
                && (
                  <Link to="/mywallet">
                    <div className="options" onClick={() => props.handleRedirection('/mywallet', true)}>
                      <ListItemText primary={text} />
                    </div>
                  </Link>
                )
              }
              {
                index == 3 && isSubscribed
                && (
                  <Link to="/">
                    <div className="options" onClick={() => props.handleRedirection('/', true)}>
                      <ListItemText primary={text} />
                    </div>
                  </Link>
                )
              }
              {
                index == 4
                && (
                  <div
                    className="options"
                    onClick={() => props.handleRedirection('/preferences', true)}>
                    <ListItemText primary={text} />
                  </div>
                )
              }
              {
                index == 5
                && (
                  <div className="options">
                    <ListItemText primary={text} onClick={() => handleLogout()} />
                  </div>
                )
              }
            </ListItem>
          ))}
        </List>
      </div>
    </div>
  );

  return (
    <div>
      {['right'].map((anchor) => (
        <React.Fragment key={anchor}>
          <SwipeableDrawer
            className="swipe"
            anchor="right"
            open={value}
            onClose={toggleDrawer(false)}
            onOpen={toggleDrawer(true)}>
            {list()}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
